import { render, staticRenderFns } from "./lade_user_stock.vue?vue&type=template&id=47c23be5&scoped=true"
import script from "./lade_user_stock.vue?vue&type=script&lang=js"
export * from "./lade_user_stock.vue?vue&type=script&lang=js"
import style0 from "./lade_user_stock.vue?vue&type=style&index=0&id=47c23be5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c23be5",
  null
  
)

export default component.exports